var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionCircle = function SvgQuestionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6966A4",
    fillRule: "evenodd",
    d: "M14.667 8A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.334 0M8 5.168a.75.75 0 0 0-.75.75.5.5 0 0 1-1 0 1.75 1.75 0 1 1 3.005 1.22q-.092.095-.176.177c-.144.144-.27.27-.38.412-.146.188-.199.326-.199.441v.5a.5.5 0 0 1-1 0v-.5c0-.436.203-.79.41-1.055.152-.196.344-.387.5-.542l.128-.13A.75.75 0 0 0 8 5.167m0 6.167a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333",
    clipRule: "evenodd"
  })));
};
export default SvgQuestionCircle;